module.exports = __webpack_public_path__ + "img/about.2e256982.jpg";